import currencies from 'country-currency';
import { country } from './localization';

export const byCountry = currencies.byCountry();

const currencyInThisCountry = byCountry.get(country);
// TODO(clairbee): implement the allowlist
// const currenciesSupported = [
//   "USD",
//   "RUB"
// ];
export const currency = currencyInThisCountry;
